module.exports = __webpack_public_path__ + "static/availableThumb-917dccc439c0e05a23045e570097b9de.png";